import { Pipe, PipeTransform } from '@angular/core';
import { SettingsService } from 'src/app/core/services/settings.service';

@Pipe({
  name: 'themed',
  standalone: true,
})
export class ThemedPipe implements PipeTransform {
  host = location.host;

  logo?: string;
  loginScreen?: string;

  constructor(private settingsService: SettingsService) {
    let settings = this.settingsService.settings!;

    const s = settings?.data.find((e) => e.url === this.host);
    this.loginScreen = s?.loginScreen;
    this.logo = s?.logo;
  }

  transform(defaultValue: string, type: 'logo' | 'loginScreen'): string {
    const themedValue = this[type];

    return themedValue ?? defaultValue;
  }
}
